import React, {useState,useEffect} from "react";
import StarsIcon from "@material-ui/icons/Stars";
import FilterListIcon from "@material-ui/icons/FilterList";
function PopularPosts() {
  const [popularPosts,setPopularPosts] = useState([]);

  useEffect(() => {
    fetch(`https://recruitingmonk-v2.azurewebsites.net/posts/popular`,{
      method:'GET',
      headers:{
        'Content-Type':'application/json'
      },
    }).then(
      (response) => {
        if (response.ok) {
          console.log(response);
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      }).then(res => res.json())
      .then(response => {
        if(response.success){
          let posts = response.popularPosts.slice(0,5);
          setPopularPosts(posts);
          console.log(response)
        }
      }).catch(error => console.log(error));
  },[])

  //logic: Here, we will use state to fetch the popular posts to display.
  return (
    <>
    {popularPosts.length ?
    <div className="glass flex flex-col items-center p-2 mx-2 mb-5">
      <div className="flex flex-row items-center justify-between px-2">
        <div className="flex flex-row items-center">
          <StarsIcon fontSize="small" style={{ color: "#545454" }} />
          <h3 className="ml-2 font-semibold text-2xl">Popular Posts</h3>
        </div>
        <div>
          <FilterListIcon
            aria-controls="simple-menu"
            aria-haspopup="true"
            style={{ color: "#707070", margin: "0px 10px" }}
          />
        </div>
      </div>
      <div className="flex flex-col items-center p-3">
        {popularPosts.map((post) => (
          <div className="flex flex-row items-center my-3" style={{cursor:'pointer'}} onClick={() => (window.location.href = `http://localhost:3000/posts/${post._id}`)}>
            <p className="text-red-700 font-semibold text-xl">{getLikesLength(post.likes)}</p>
            <p className="ml-3 text-xl font-bold ">{post.content.substr(0,20)}</p>
          </div>
        ))}
      </div>
    </div> : <div></div>
    }
    </>
  );
}

const getLikesLength = (likes) => {
  let length = likes;
  if(length > 100 && length < 1000000) length = String(Number(length/100)) + "K";
  if(length > 1000000) length = String(Number(length)/1000000) + "M";
  return length;
}

export default PopularPosts;
